<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type} input-${size}`"
    :data-type="context.type"
  >
    <date-picker
      v-bind="context.attributes"
      v-model="context.model"
      :value-type="context.attributes?.valueType || context.attributes?.['value-type'] || 'format'"
      :placeholder="context.attributes?.placeholder || 'Pilih Tanggal'"
      :type="datepickerType"
      ref="periodePicker"
      @blur="context.blurHandler()"
      :disabled-date="disabledDate"
      :lang="datePickerLang"
      :shortcuts="shortcuts"
      @pick="pickDate"
    >
      <template #footer v-if="context.attributes.cancel">
        <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">{{
          $t('global.action.cancel')
        }}</b-button>
      </template>
      <template #icon-calendar>
        <i class="icon-outline_calendar"></i>
      </template>
    </date-picker>
  </div>
</template>

<script>
import datePickerLang from '@/helpers/date-picker-lang'
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    datepickerType: {
      type: String,
      default: 'date',
    },
    disabledDate: {
      type: Function,
      default: () => false,
    },
    shortcuts: {
      required: false,
    },
    pickDate: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    datePickerLang() {
      return datePickerLang()
    },
  },

  methods: {
    closeCalendar() {
      this.$refs.periodePicker.defaultOpen = false
    },
  },
}
</script>
